import { render, staticRenderFns } from "./box1.vue?vue&type=template&id=75e1a0dd&scoped=true&"
import script from "./box1.vue?vue&type=script&lang=ts&"
export * from "./box1.vue?vue&type=script&lang=ts&"
import style0 from "./box1.vue?vue&type=style&index=0&id=75e1a0dd&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75e1a0dd",
  null
  
)

export default component.exports